import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_96: FaireProductEntity = {
  token: "legacy_prod_abbott-96",
  type: "product",
  name: 'Butterfly Edged Planter 7" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/22408f4672c0714dc5150c7bcb4df1b60af5285cb9fcc8d8171365021f843cac.jpeg",
  priceDollars: 28,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
